import * as W from 'wix-bi-logger'
import { utils } from './utils';

// var W;

class BiLogger {

  constructor(wixBiArgs, biParams, paramsVerifier) {
    this.biParams = biParams
    this.needsGalleryType = evid => [401, 403, 406, 500, 501, 502, 700, 703, 704].indexOf(evid) > -1
    this.initVisitorId();
    // predefine events
    this.biLogger = (W && W.BI) ? (new W.BI.Logger(wixBiArgs)) : false;
    this.paramsVerifier = paramsVerifier || function (biEvents) {
        console.log('Default BI validator', biEvents);
        return true;
      };

    this.biEvents = {
      sample: {
        evid: 1,
      },
      add_pro_gallery: {
        evid: 400
      },
      change_settings: {
        evid: 401
      },
      mange_media_upper_panel_open: {
        evid: 402
      },
      pro_gallery_settings_load: {
        evid: 403
      },
      manage_media_set: {
        evid: 404
      },
      manage_media_text_editor_customize: {
        evid: 405
      },
      upload_media: {
        evid: 406
      },
      upload_media_error: {
        evid: 407
      },
      remove_media_from_gallery: {
        evid: 408
      },
      layouts_select: {
        evid: 409
      },
      gallery_performance: {
        evid: 410
      },
      // choose_provider: {
      //   evid: 420
      // },
      // activate_store_click: {
      //   evid: 421
      // },
      // media_sell_wizard_started: {
      //   evid: 422
      // },
      // set_pricing: {
      //   evid: 423
      // },
      // set_pricing_add_product_click: {
      //   evid: 424
      // },
      // set_pricing_ass_product_success: {
      //   evid: 425
      // },
      // manage_store_connect_paypal_success: {
      //   evid: 426
      // },
      // manage_store_connect_paypal_error: {
      //   evid: 427
      // },
      // manage_store_stats_click: {
      //   evid: 428
      // },
      // manage_store_my_profile_set: {
      //   evid: 429
      // },
      share: {
        evid: 500
      },
      love: {
        evid: 501
      },
      download: {
        evid: 502
      },
      info: {
        evid: 503
      },
      expand: {
        evid: 504
      },
      payment_excepted: {
        evid: 506
      },
      payment_error: {
        evid: 507
      },
      pro_gallery_load_error: {
        evid: 509
      },
      pro_gallery_loaded: {
        evid: 510
      },
      pro_gallery_error: {
        evid: 512
      },
      pro_gallery_load_users: {
        evid: 177,
      },
      pro_gallery_load_uou: {
        evid: 304,
      },
      select_photo: {
        evid: 600,
      },
      share_group: {
        evid: 601,
      },
      log_reach_level: {
        evid: 602,
      },
      manageMediaClick: {
        evid: 700
      },
      storeSetUpTab: {
        evid: 702
      },
      expandSettings: {
        evid: 703
      },
      expandSettingsDone: {
        evid: 704
      },
      watermarkSettings: {
        evid: 705
      },
      watermarkEnable: {
        evid: 706
      },
      cartSettings: {
        evid: 708
      },
      cartSettingsDesignTab: {
        evid: 709
      },
      buyNowClick: {
        evid: 800
      },
    };

    this.paramsVerifier(this.biParams);
  }

  getGalleryType() {
    return utils.isStoreGallery() ? 'store' : 'progallery'
  }

  track(eventName, params, callback) {
    const biEvent = this.biEvents[eventName];
    if (!biEvent) {
      console.error('TRACK EVENT ERROR - No such bi event ' + eventName);
      return false;
    } else {
      return this.trackBi(biEvent, params, callback);
    }
  }

  trackBi = (biEvent, params = {}, callback) => {

    if (!biEvent) {
      console.error('TRACK EVENT ERROR - No such bi event');
      return false;
    }

    // if (utils && utils.isDev()) {
    //   // comment the following line to send biEvents in development
    //   console.log('Not tracking bi events in dev', biEvent, additionalParams);
    //   return;
    //   // console.log('logger.track', biEvent.evid, additionalParams);
    //   // console.warn('Sending logger events in dev');
    // }

    if (!this.paramsVerifier(this.biParams)) {
      console.error('TRACK EVENT ERROR - Missing biParams', this.biParams);
      return false;
    }

    var evid = biEvent.evid;

    if (this.isUserOfUserEvent(evid)) {
      if (utils.getViewModeFromCache() !== 'site') {
        //console.log('Not tracking UoU events in', Wix.Utils.getViewMode(), 'mode');
        return;
      }

      if (this.visitorId == null) {
        let errorMsg = 'visitor id is undefined. It is needed for user of user events. evid:' + biEvent.evid;
        console.error(errorMsg);
        return;
      }
      params['visitor_id'] = this.visitorId
    }

    if (this.needsGalleryType(evid)) {
      params['galleryType'] = this.getGalleryType()
    }

    try {
      var defParams = (biEvent.defaultParams || {});
      var logData = $.extend({}, defParams, params, this.biParams);
      this.biLog(evid, logData, callback);
    } catch (e) {
      console.warn('BI LOGGER ERROR!', e);
    }
  }

  stats(stats_token, instance_id, album_id, action) {
    var value = 1;
    if (action === 'unlove') {
      value = -1;
      action = 'love';
    }

    var uniqueUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });

    $.ajax({
      url: window.location.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + stats_token,
      type: 'post',
      data: JSON.stringify({
        'messageId': uniqueUUID,
        'metrics': [
          {
            'type': 'album',
            'reportMetrics': [
              {
                'name': action,
                'value': value
              },
            ],
            properties: {
              'instance_id': instance_id,
              'album_id': album_id
            }
          }
        ]
      }),
      contentType: 'application/json',
      dataType: 'json',
      success: function (data) {
        console.log('yeeee');
      }
    });
  }

  biLog(evid, params, callback) {

    if (!this.biLogger) {
      console.warn('no biLogger, cannot log event');
      return;
    }
    if (typeof evid == 'undefined') {
      console.warn('evid is missing, cannot log event', evid, params);
      return;
    }
    if (typeof params == 'undefined') {
      console.warn('params are missing, cannot log event', evid, params);
      return;
    }

    var logData = $.extend({evid: evid}, params);

    let adapter = this.getAdapter(evid);
    if (adapter != null) {
      $.extend(logData, {adapter});
    }
    this.biLogger.log(logData, callback);
  }

  isBot() {
    return (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent));
  }

  trackLoadBi(endpoint) {
    let eventType = (utils.getViewModeFromCache() == 'site') ? this.biEvents.pro_gallery_load_uou : this.biEvents.pro_gallery_load_users;
    try {
      if (!this.isBot()) {
        if ((eventType == this.biEvents.pro_gallery_load_users) || this.visitorId) {
          this.trackBi(eventType, {endpoint, loading_time: window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart});
        } else {
          this.onInitVisitorId = () => this.trackLoadBi(endpoint)
        }
      }
    } catch (e) {
      console.error('track load event error', e);
    }
  }

  initBiLoadedEventListener(endpoint) {
    window.addEventListener('load', () => {
      this.trackLoadBi(endpoint);
    })
  }

  initVisitorId() {
    if (utils.getViewModeFromCache() !== 'site') {
      return
    }
    if (typeof(Promise) == 'undefined') {
      console.error('promise is undefined in initVisitorId. Cant init visitor id')
      return
    }
    const timeOut = 9000
    const beginTime = Date.now()
    // const sessionTokenToVisitorId = s => [[0, 8], [8, 12], [12, 16], [16, 20], [20, 32]].map(i => s.slice(...i)).join('-');
    // new Promise(resolve => Wix.Activities.getUserSessionToken(resolve))
    //   .then(sessionTokenToVisitorId)
    //   .then(val => {
    new Promise(resolve => resolve(Wix.Utils.getInstanceValue('aid') || Wix.Utils.getInstanceValue('uid')))
      .then(val => {
        this.visitorId = val
        this.onInitVisitorId && this.onInitVisitorId()
        const interval = Date.now() - beginTime
        if (interval > timeOut) {
          console.error(`took over ${timeOut}ms to get the visitor id`, interval + 'ms')
        }
      })
      .catch(err => console.error('cant get visitorID/sessionToken', err))

    setTimeout(() => {
      if (!this.visitorId) {
        console.error(`waiting ${timeOut}ms for visitorID/sessionToken`)
      }
    }, timeOut)
  }

  isInRange(val, min, max) {
    return val >= min && val < max;
  };

  isUserEvent(evid) {
    return !this.isUserOfUserEvent(evid);
  };

  isUserOfUserEvent(evid) {
    return (this.isInRange(evid, 500, 605) || evid === 304 || evid === 800);
  };

  getAdapter(evid) {
    let adapter;
    if (this.isUserEvent(evid)) {
      adapter = 'photo-users';
    } else if (this.isUserOfUserEvent(evid)) {
      adapter = 'photo-ugc';
    } else {
      console.error('evid', evid, 'is not user, or uou event (???)');
    }
    return adapter;
  };

  static getParam(val) {

    var vmDefaultStringRegex = /^\$\{.*\}$/; //e.g. "${instance}" or "${some_variable}"
    var windowVal = String(window[val]);

    if (windowVal && vmDefaultStringRegex.exec(windowVal) == null) {
      return windowVal;
    } else {
      var result = '',
        tmp = [];
      location.search
      //.replace ( "?", "" )
      // this is better, there might be a question mark inside
        .substr(1)
        .split('&')
        .forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
      return result;
    }
  };

}

const wixBiArgs = {
  defaultEventArgs: {},
  defaultErrorArgs: {},
  adapter: 'photo-users'
}

const biParamsObj = {
  instance_id: BiLogger.getParam('instanceId'),
  gallery_id: BiLogger.getParam('galleryId'),
  src: 65 //predefined wix-albums source
}

const paramsVerifier = (biParams) => {
  var isValid = false;
  if (biParams['biToken']) {
    isValid = true;
  } else {
    try {
      biParams['biToken'] = Wix.Utils.getInstanceValue('biToken');
      isValid = true;
    } catch (e) {
      if (utils && utils.isDev()) {
        isValid = true;
      } else {
        console.warn('Error parsing biToken from instance!', e);
        isValid = false;
      }
    }
  }

  if (utils.isDev()) {
    console.log('Verify BI params:', biParams, 'is valid:', isValid);
  }

  return isValid;
}
export const logger = window['logger'] = new BiLogger(wixBiArgs, biParamsObj, paramsVerifier);



// WEBPACK FOOTER //
// ./utils/biLogger.js